module.exports = __webpack_public_path__ + "img/untergriesbach.1fa58b9.jpg";